import React, { useState } from "react";
import styled from "styled-components";
import { Link as LinkS } from "react-scroll";
import { RiArrowLeftSFill as ArrowLeft } from "react-icons/ri";
import { RiArrowRightSFill as ArrowRight } from "react-icons/ri";
import Timer from "../Timer";

const SidebarWrapper = styled.div`
  padding: 10px;
  margin: 15px;
  padding-left: 0px;
  margin-left: 0px;
  margin-top: 120px;
  border-radius: 50px;
  background: #0b0040;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  align-items: center;
`;

const ShrunkWrapper = styled.div`
  padding: 5px;
  margin: -10px;
  padding-left: 0px;
  margin-top: 60px;

  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  align-items: center;
`;
const SidebarButtons = styled(LinkS)`
  cursor: pointer;
  color: white;
  font-size: 16px;
  &:hover {
    text-decoration: none;
    color: #ec0f8c;
    font-weight: bold;
  }
  &.active {
    color: #ec0f8c;
    font-weight: bold;
  }
`;

const SidebarButtonWrappers = styled.div`
  margin: 5px;
`;

const SidebarContainer = styled.div`
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  position: fixed;
  width: 300px;
  height: 150px;
  z-index: 301;
  bottom: 15px;
  right: 15px;
  border-radius: 200px;
  background: #0b0040;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

const ShrunkSidebarContainer = styled.div`
  display: ${({ isOpen }) => (isOpen ? "none" : "flex")};
  position: fixed;
  z-index: 301;
  bottom: 85px;
  right: 24px;
  font-size: 30px;
  border-radius: 80px;
  background: #0b0040;
  height: 60px;
  width: 60px;
  padding: 15px;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  @media (max-width: 560px) {
    right: 10px;
    bottom: 70px;
  }
`;

const Left = styled(ArrowLeft)`
  color: white;
  width: 30px;
  height: 30px;
`;

const Right = styled(ArrowRight)`
  color: white;
  height: 100%;
  width: 100%;
`;

const ArrowButton = styled.button`
  width: 40px;
  height: 30px;
  background: none;
  border: none;
`;

export const SidebarObject = (props) => {
  const { sidebarData, toggle, isOpen } = props;
  const time = new Date();
  time.setSeconds(time.getSeconds() + 600);

  return (
    <>
      <ShrunkSidebarContainer isOpen={isOpen}>
        <button
          style={{ background: "none", padding: "0px", marginLeft: "-2.5px" }}
          onClick={toggle}
        >
          {/* <Right /> */}⏰
        </button>
      </ShrunkSidebarContainer>
      <SidebarContainer isOpen={isOpen}>
        <ArrowButton onClick={toggle}>
          <Right />
        </ArrowButton>
        <Timer expiryTimestamp={time} />
      </SidebarContainer>
    </>
  );
};
